// this page created by akash-ak
import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../../Components/Pagination";
import Button from "../../../../../Core/Button/Button";

const Table1 = ({ title, extradata, columns, status }) => {
  console.log(columns, "columns-table1");
  console.log(extradata?.uomdata, "uomdata");

  const createNewRow = () => {
    const baseRow = {};
    columns.forEach((col) => {
      baseRow[col.field] = "";
    });
    return baseRow;
  };

  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([createNewRow()]);
  const [selectedRows, setSelectedRows] = useState([]);
  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div
      style={{
        border: "1px solid #00000059",
        borderRadius: "5px",
        marginBottom: "20px",
        marginTop: "20px",
        padding : '10px'
      }}
    >
      {/* <div className="col-12">
        <p className="boxLabel m-0">Gate Entry Details</p>
      </div> */}

      <div>
        <p className=" m-0">{title}</p>

        <table className="table table-bordered mb-1" ref={tableRef}>
          <thead className="tableHead1">
            <tr>
              {columns.map((col, i) => (
                <th
                  key={i}
                  style={{
                    fontSize: "7px",
                    position: "relative",
                    textAlign:
                      col.title === "Action" || col.title === "Sl.No"
                        ? "center"
                        : "left",
                    width: col.width || "150px",
                    minWidth: col.width || "150px",
                  }}
                >
                  {col.title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        backgroundColor: isAllSelected ? "#270b79" : "",
                        borderColor: isAllSelected ? "#270b79" : "",
                        fontSize: "15px",
                      }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : (
                    col.title
                  )}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {currentRows.map((row, index) => {
              const globalIndex = indexOfFirstRow + index;

              return (
                <tr key={globalIndex}>
                  {columns.map((col, colIndex) => {
                    const field = col.field;
                    const value = row[field] || "";
                    const isSelected = selectedRows.includes(globalIndex);

                    // Action Checkbox
                    if (field === "action") {
                      return (
                        <td
                          key={colIndex}
                          className="p-0"
                          style={{ textAlign: "center" }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={isSelected}
                            onChange={() => toggleRowSelection(globalIndex)}
                            style={{
                              backgroundColor: isSelected ? "#270b79" : "",
                              borderColor: isSelected ? "#270b79" : "",
                              fontSize: "15px",
                            }}
                          />
                        </td>
                      );
                    }

                    // Serial No
                    if (field === "sl_no") {
                      return (
                        <td
                          key={colIndex}
                          style={{
                            textAlign: "center",
                            fontSize: "0.8rem",
                            padding: "0.5rem",
                          }}
                        >
                          {globalIndex + 1}
                        </td>
                      );
                    }

                    // UOM Dropdown
                    if (field === "oum") {
                      const uomOptions = extradata?.uomdata || [];
                      return (
                        <td key={colIndex} className="p-0">
                          <select
                            className="form-control tableinput noborder"
                            style={{ fontSize: "0.8rem" }}
                            value={value}
                            onChange={(e) =>
                              updateRow(globalIndex, field, e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            {uomOptions.map((opt, idx) => (
                              <option key={idx} value={opt.value}>
                                {opt.value}
                              </option>
                            ))}
                          </select>
                        </td>
                      );
                    }

                    // Default text input
                    return (
                      <td key={colIndex} className="p-0">
                        <input
                          type="text"
                          className="form-control tableinput noborder"
                          style={{ fontSize: "0.8rem" }}
                          value={value}
                          onChange={(e) =>
                            updateRow(globalIndex, field, e.target.value)
                          }
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="d-flex pb-2 justify-content-between align-items-center">
          <div className="d-flex" style={{ gap: "4px" }}>
            {selectedRows.length > 0 && status === "" && (
              <Button
                onClick={handleDeleteSelectedRows}
                className="customdeletebtn"
                iconName="MdDeleteOutline"
                iconSize={12}
              >
                Delete
              </Button>
            )}
            <Button
              onClick={handleAddRow}
              className="Addrowdesign"
              iconName="FiPlus"
              iconSize={12}
              iconWrapperStyle={{
                backgroundColor: "#ff8d5c",
                padding: "1px",
                display: "flex",
              }}
            >
              Add Row
            </Button>
          </div>

          <div
            className={`${rows.length < 11 ? "d-none" : "d-flex"
              } align-items-center centerpagination`}
            style={{ gap: "5px" }}
          >
            <Pagination
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pageSize={rowsPerPage}
              totalrecords={rows.length}
            />
          </div>

          <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
            <span
              className="px-2"
              style={{ fontSize: "12px", color: "#270B79" }}
            >
              Showing {indexOfFirstRow + 1} to{" "}
              {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table1;
